export class AysArtificialRespirationHours {

    public static fromObject(
        obj: {from: number, to: number},
    ): AysArtificialRespirationHours {
        return new AysArtificialRespirationHours(
            obj.from,
            obj.to
        );
    }

    constructor(
        public from: number,
        public to: number
    ) {
    }

    public equals(
        toCompare: AysArtificialRespirationHours
    ): boolean {
        return this.to === toCompare.to &&
            this.from === toCompare.from;
    }

    public clone(): AysArtificialRespirationHours {
        return new AysArtificialRespirationHours(
            this.from,
            this.to
        );
    }
}
